// extracted by mini-css-extract-plugin
export default {"container":"OpinionSection_container__qQqU0","carouselContainer":"OpinionSection_carouselContainer__URsU+","cardContainer":"OpinionSection_cardContainer__3nn+4"};